import { SitesMultipleClusterIcon } from '@tableau/icons/SitesMultipleClusterIcon';
import { Tooltip } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';

import { ClusterNodePresenceIcon } from '../dataConnectClusterNodes/ClusterNodePresenceIcon';
import { getClusterNodeStatus } from '../dataConnectClusterNodes/ClusterNodeStates';
import { Cluster } from '../types/Cluster';
import { ClusterNamePopover } from './ClusterNamePopover';
import { textCellPadding } from './DataConnectMultiClusterTableHeaders';


export type SharedClusterTableEntryClusterProps = Readonly<{
  cluster: Cluster;
}>;

export function DataConnectSharedClusterTableEntryCluster(props: SharedClusterTableEntryClusterProps) {
  const { cluster} = props;

  let clusterCellStyle =  textCellPadding + ' tb-data-grid-separator-row ';

  const clusterNodeStatus = getClusterNodeStatus();
  return <>
    <td className={clusterCellStyle} >
      <ClusterNamePopover cluster={cluster}/>
      <span style={{paddingLeft: 4, verticalAlign: 'text-top'}}>
        <Tooltip children={<SitesMultipleClusterIcon size={12} alt={''} />}
               tooltipContent={Messages.dataConnectSiteSettingsClusterShared()}
               position={Tooltip.defaultProps.position!}
               afterDelay={false}
               followCursor={false} />
      </span>
    </td>
    <td className={clusterCellStyle}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'cluster-status-cell'}>
        {<ClusterNodePresenceIcon status={cluster.status} clusterNodeStatus={clusterNodeStatus} />}
        {clusterNodeStatus[cluster.status] === undefined ? clusterNodeStatus.Available.stateLabel : clusterNodeStatus[cluster.status].stateLabel}
      </span>
    </td>
    <td className={clusterCellStyle} style={{textAlign: 'left'}}>
      <span className={'tb-data-grid-cell-text-data-connect tb-lr-padded-wide'} data-tb-test-id={'cluster-memory-cell'}>
        {cluster.numberOfNodes}
      </span>
    </td>
    <td className={clusterCellStyle} style={{width: '50%'}}>
      {}
    </td>
  </>;
}
